// ----------------------------------------------------------------------------
// Snippet: Pagination
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------


// -------------------------------------
// Dependencies
// -------------------------------------

// Styles
import './_pagination.scss';